import moment from 'moment-timezone'

type TTimeseriesPoint = { timestamp: string; value: number | null }

export type TTrapWindowCounts = {
  today: number | null
  past7Days: number | null
  past14Days: number | null
  yearToDate: number | null
}

export const sliceTrapTimeseries = (timeseries: TTimeseriesPoint[]): TTrapWindowCounts => {
  if (timeseries.length === 0) {
    return { today: null, past7Days: null, past14Days: null, yearToDate: null }
  }

  const timezone = moment.tz.guess()
  const now = moment.tz(timezone)
  const startOfToday = now.clone().startOf('day')
  const past7Cutoff = now.clone().subtract(7, 'days').startOf('day')
  const past14Cutoff = now.clone().subtract(14, 'days').startOf('day')
  const startOfYear = now.clone().startOf('year')

  let todayCount: number | null = null
  let past7Sum = 0
  let past14Sum = 0
  let ytdSum = 0
  let past7HasData = false
  let past14HasData = false
  let ytdHasData = false

  for (const point of timeseries) {
    if (point.value === null) continue

    const ts = moment.tz(point.timestamp, timezone)

    if (ts.isSameOrAfter(startOfToday)) {
      todayCount = (todayCount ?? 0) + point.value
    }

    if (ts.isSameOrAfter(past7Cutoff)) {
      past7Sum += point.value

      past7HasData = true
    }

    if (ts.isSameOrAfter(past14Cutoff)) {
      past14Sum += point.value

      past14HasData = true
    }

    if (ts.isSameOrAfter(startOfYear)) {
      ytdSum += point.value

      ytdHasData = true
    }
  }

  return {
    today: todayCount,
    past7Days: past7HasData ? past7Sum : null,
    past14Days: past14HasData ? past14Sum : null,
    yearToDate: ytdHasData ? ytdSum : null,
  }
}
